// Email Notification Service
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

// Initialize callable functions
const sendContactNotification = httpsCallable(functions, 'sendContactNotification');
const sendPaymentNotification = httpsCallable(functions, 'sendPaymentNotification');
const sendCustomNotification = httpsCallable(functions, 'sendCustomNotification');
const testEmailNotification = httpsCallable(functions, 'testEmailNotification');

// Email notification service class
class EmailNotificationService {

  // Send contact form notification
  static async notifyContactForm(formData) {
    try {
      const result = await sendContactNotification(formData);
      console.log('Contact notification sent:', result.data);
      return result.data;
    } catch (error) {
      console.error('Error sending contact notification:', error);
      throw error;
    }
  }

  // Send payment notification
  static async notifyPayment(paymentData) {
    try {
      const result = await sendPaymentNotification(paymentData);
      console.log('Payment notification sent:', result.data);
      return result.data;
    } catch (error) {
      console.error('Error sending payment notification:', error);
      throw error;
    }
  }

  // Send custom notification
  static async notifyCustom(type, data) {
    try {
      const result = await sendCustomNotification({ type, data });
      console.log('Custom notification sent:', result.data);
      return result.data;
    } catch (error) {
      console.error('Error sending custom notification:', error);
      throw error;
    }
  }

  // Test email functionality
  static async testEmail() {
    try {
      const result = await testEmailNotification();
      console.log('Test email sent:', result.data);
      return result.data;
    } catch (error) {
      console.error('Error sending test email:', error);
      throw error;
    }
  }

  // Helper function to notify about user registrations (manual trigger)
  static async notifyUserRegistration(userData) {
    return this.notifyCustom('userRegistration', userData);
  }

  // Helper function to notify about training registrations (manual trigger)
  static async notifyTrainingRegistration(userData) {
    return this.notifyCustom('trainingRegistration', userData);
  }

  // Helper function to notify about institutional portfolio registrations
  static async notifyInstitutionalRegistration(userData) {
    return this.notifyCustom('institutionalRegistration', userData);
  }
}

export default EmailNotificationService;